<template>
	<div class="enter registration cover">
		<!-- Outer -->
		<div class="enter__outer">

			<!-- Enter Inner -->
			<div class="enter__inner registration__enter-inner">
				<div class="main-logo registration__logo">
					<img class="main-logo__item" src="../../../assets/img/logo.png" alt="logo">
				</div>
			</div>
			<!-- Enter Inner End -->

			<!-- Enter Inner -->
			<div class="enter__inner">
				<form id="entry_form" class="enter-form registration__form" @submit.prevent="createUser">
					<!-- <p class="enter__text">Придумайте пароль</p> -->

					<!-- Enter Label -->
					<label class="enter__label" for="password">Пароль
						<input v-model="password" class="enter-text-field enter-text-field_margin_n" id="password" type="password">
						<img class="enter__icon enter__icon_show-pass" src="../../../assets/img/svg/eye.svg" alt="Показать пароль"
								 @click='showPassword'>
					</label>
					<!-- Enter Label End -->


					<!-- Enter Label -->
					<label class="enter__label" for="rePassword">Повторите пароль
						<input v-model="rePassword" class="enter-text-field enter-text-field_margin_n" id="rePassword" type="password">
						<img class="enter__icon enter__icon_show-pass" src="../../../assets/img/svg/eye.svg" alt="Показать пароль"
								 @click='showRePassword'>
					</label>
					<!-- Enter Label End -->

					<input class="enter-form__button" type="submit" value="Далее">
					<p class="enter__text">Шаг 3 из 4</p>
				</form>
				
			</div>
			<!-- Enter Inner End -->

		</div>
		<!-- Outer End -->

	</div>
</template>

<script>
	export default {
		name: "ThirdStep",
		data() {
			return {
				password: "",
				rePassword: "",
				isShow: false,
				isReShow: false
			}
		},
		methods: {
			createUser() {
				if(!this.password || !this.rePassword) {
					this.$event.toast('e', 'Введите пароль, пожалуйста')
					return false
				}

				if(this.password !== this.rePassword) {
					this.$event.toast('e', 'Пароли не совпадают')
					return false
				}

				this.$storage.set('reg.password', this.password)
				this.$storage.set('reg.rePassword', this.rePassword)

				this.$router.push({name: 'Four'})
			},
			showPassword() {
				this.isShow = !this.isShow
				document.getElementById('password').type = (this.isShow) ? 'text' : 'password'
			},
			showRePassword() {
				this.isReShow = !this.isReShow
				document.getElementById('rePassword').type = (this.isReShow) ? 'text' : 'password'
			}
		}
	}
</script>

<style scoped>

	.registration label[for=password] {
		position: relative;
	}

	input.is-danger {
		border-color: red;
	}

	span.is-danger {
		color: rgb(255, 84, 0);
	}

	input[type=submit] {
		margin-top: 15px;
	}

</style>



// WEBPACK FOOTER //
// Three.vue?69368e60